import { Skeleton } from '@/components/ui/skeleton'
import { AppBoxFallback } from '@/routes/pipeline/pipeline-board/app-box/fallback'
import * as Styled from '@/routes/pipeline/pipeline-board/styles'

export const PipelineBoardFallback = () => {
  return (
    <Styled.PipelineBoardWrapper>
      <Styled.PipelineStageWrapper className="p-5 pb-20">
        <div className="flex items-start gap-4 min-w-max justify-center flex-grow">
          <div className="p-0 min-w-[300px] max-w-[350px] flex-[1_1_0px] z-[1] space-y-4">
            <Skeleton className="flex h-8.5 w-full mb-4 border" />
            {Array.from({ length: 2 })?.map((_, index) => (
              <AppBoxFallback hasFooter key={index} />
            ))}
          </div>
          <div className="p-0 min-w-[300px] max-w-[350px] flex-[1_1_0px] z-[1] space-y-4">
            <Skeleton className="flex h-8.5 w-full mb-4 border" />
            {Array.from({ length: 1 })?.map((_, index) => (
              <AppBoxFallback hasFooter key={index} />
            ))}
          </div>
          <div className="p-0 min-w-[300px] max-w-[350px] flex-[1_1_0px] z-[1] space-y-4">
            <Skeleton className="flex h-8.5 w-full mb-4 border" />
            {Array.from({ length: 2 })?.map((_, index) => (
              <AppBoxFallback key={index} />
            ))}
          </div>
        </div>
      </Styled.PipelineStageWrapper>
    </Styled.PipelineBoardWrapper>
  )
}
